var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('vue-scroll-progress-bar',{attrs:{"id":"scroll-bar","height":"5px","backgroundColor":"#e76f51"}}),_c('vue-scroll-snap',[_c('Info'),_c('Timeline'),_c('Hobbies')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }